export enum HardwareType {
    OLD = 'old',
    NEW = 'new'
}



// WEBPACK FOOTER //
// ./src/app/enums/hardware-type.enum.ts